export default {
  TYPE_CLIENT_CAREPLAN: 'client-cp',
  TYPE_BILLING_PRODA: 'proda',
  TYPE_BILLING_INVOICE: 'invoice',
  TYPE_BILLING_HR_BALANCE: 'hr-balance',
  TYPE_BILLING_PAYROLL: 'payroll',
  TYPE_CONTACTS_GENERAL_SIMPLE: 'general-simple'
}
